import React from 'react';

function Chat() {
  return (
    <section className="tc-chat-style1">
      <div className="container">
        <div className="content">
        <a href="mailto:db@dbarchitekt.com" className="xl-text">db@dbarchitekt.com</a>
          <h5 className="mb-50 lh-5 db-color">
            Let us help your dream <br /> become reality
          </h5>
        </div>
      </div>
      <img src="/home1/assets/img/c_line4.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Chat;
